import { Box, Chip, Typography } from "@mui/material";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { JobDetailViewModel } from "./jobDetailTypes";
import { DetailCard } from "./DetailCard";

type Props = {
  job: JobDetailViewModel;
};

export default function InvoiceCard({ job }: Props) {
  const isMissing = job.invoiceStatus === "missing";
  const isPending = job.invoiceStatus === "pending" || isMissing;
  return (
    <DetailCard title="Invoice">
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <Chip
          label={isMissing ? "MISSING" : isPending ? "PENDING" : "UPLOADED"}
          size="small"
          sx={{
            height: 22,
            fontSize: 10,
            fontWeight: 700,
            backgroundColor: isPending || isMissing ? "#FFEBEE" : "#E8F5E9",
            color: isPending || isMissing ? "#C62828" : "#2E7D32",
          }}
        />
      </Box>

      <Box
        sx={{
          border: "2px dashed #E0E0E0",
          borderRadius: "8px",
          py: 4,
          px: 2,
          textAlign: "center",
          cursor: "pointer",
          "&:hover": { backgroundColor: "#FAFAFA" },
        }}
      >
        <CloudUploadOutlinedIcon sx={{ fontSize: 32, color: "text.disabled", mb: 1 }} />
        <Typography variant="body2" color="text.secondary">
          Click to upload invoice PDF
        </Typography>
      </Box>
    </DetailCard>
  );
}
